module.exports = __webpack_public_path__ + "img/KZ.aebe1ef9.svg";